import { computed, defineComponent, provide, reactive, toRefs } from 'vue';
import { QTableProps } from 'node_modules/quasar/dist/types/index';
import useQuasar from 'quasar/src/composables/use-quasar.js';;

import { ExportField } from '../../interfaces/export-fields';
import { warningNotify } from '@/helpers/utilities';
import { TableStyle } from '@/ui/components/tables/enums/type-style';

interface Props {
    toggleExportField: boolean;
    fields: ExportField[]
}

export default defineComponent({
    name: 'ExportFieldComponent',
    props: {
        toggleExportField: {
            type: Boolean,
            required: true
        },
        fields: {
            type: Array as () => ExportField[],
            required: true 
        }
    },
    setup(props: Props, { emit }) {
        const toggleExportFieldModal = computed({
            get() { return props.toggleExportField },
            set(newValue) { emit('update:toggleExportField', newValue) }
        });

        const aplicationTable = reactive({
            rows: props.fields,
            columns: [
                { name: 'label', label: 'Campo', field: 'label', align: "left" },
            ] as QTableProps['columns'],
            dense: true,
            loading: false,
            selectedItems: props.fields,
        });
        provide('dataTable', aplicationTable);

        const $q = useQuasar();

        const updateSelectedItems = (items: ExportField[]) => {
            aplicationTable.selectedItems = items;
        }

        const onAccept = () => {
            if (aplicationTable.selectedItems.length <= 0) {
                $q.notify(warningNotify('Se debe seleccionar al menos un campo para poder exportar'));
                return;
            }
            
            emit('items-selected', aplicationTable.selectedItems);
            emit('update:toggleExportField', false);
        }

        return {
            ...toRefs(aplicationTable),
            toggleExportFieldModal,
            updateSelectedItems,
            onAccept,
            TableStyle
        }
    }
});